/** Only the topmost open popover handles a dismissal gesture. */
export class PopoverStack {
  private layers: { id: symbol; depth: number }[] = [];
  private handled = new WeakSet<Event>();

  add(id: symbol, depth: number): () => void {
    this.layers.push({ id, depth });
    return () => { this.layers = this.layers.filter(layer => layer.id !== id); };
  }

  claim(id: symbol, event: Event): boolean {
    if (this.handled.has(event)) return false;
    const top = this.layers.reduce<(typeof this.layers)[number] | undefined>((top, layer) =>
      !top || layer.depth >= top.depth ? layer : top, undefined);
    if (top?.id !== id) return false;
    this.handled.add(event);
    return true;
  }
}
